module.exports = __webpack_public_path__ + "img/header_pre.52c4e065.jpg";